import React from 'react';
import { Helmet } from "react-helmet-async";
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function About() {
  return (
    <div style={{ background: '#f5f7fa' }}>
      <Helmet>
        <title>About Broadway Holidays – Trusted UK Holiday Company</title>
        <meta
          name="description"
          content="Learn about Broadway Holidays, a trusted UK-based Holiday company committed to delivering personalised holiday experiences with reliable customer support."
        />
        <meta name="robots" content="index,follow" />
      </Helmet>

      <Navbar />
      
      <header style={{
        background: 'linear-gradient(135deg, #6a4c93 0%, #553c7a 100%)',
        color: '#fff',
        padding: '60px 20px',
        textAlign: 'center',
      }}>
        <h1 style={{ fontSize: '48px', marginBottom: '15px' }}>About Broadway Holidays</h1>
        <p style={{ fontSize: '20px', opacity: 0.9 }}>Your trusted partner for unforgettable holidays</p>
      </header>

      <div style={{ maxWidth: '1000px', margin: '60px auto', padding: '0 20px' }}>
        <div style={{ background: '#fff', padding: '40px', borderRadius: '15px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', marginBottom: '40px' }}>
          <h2 style={{ fontSize: '32px', color: '#6a4c93', marginBottom: '20px' }}>Our Story</h2>
          <p style={{ fontSize: '18px', lineHeight: '1.8', color: '#555', marginBottom: '15px' }}>
            Founded in 2015, Beach Holidays has been making dream vacations a reality for thousands of travelers. 
            We specialize in curating the perfect beach getaways, from luxury resorts to budget-friendly escapes.
          </p>
          <p style={{ fontSize: '18px', lineHeight: '1.8', color: '#555' }}>
            Our passion for Holidays and commitment to exceptional service has made us one of the UK's most trusted 
            holiday providers. We believe every journey should be memorable, affordable, and stress-free.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '30px', marginBottom: '60px' }}>
          {[
            { icon: '🌍', number: '50K+', label: 'Happy Travelers' },
            { icon: '🏖️', number: '100+', label: 'Destinations' },
            { icon: '⭐', number: '4.8/5', label: 'Customer Rating' },
            { icon: '📅', number: '10', label: 'Years Experience' },
          ].map((stat, idx) => (
            <div key={idx} style={{
              background: 'linear-gradient(135deg, #6a4c93 0%, #553c7a 100%)',
              color: '#fff',
              padding: '40px 20px',
              borderRadius: '15px',
              textAlign: 'center',
            }}>
              <div style={{ fontSize: '48px', marginBottom: '15px' }}>{stat.icon}</div>
              <h3 style={{ fontSize: '36px', margin: '10px 0' }}>{stat.number}</h3>
              <p style={{ fontSize: '16px', opacity: 0.9 }}>{stat.label}</p>
            </div>
          ))}
        </div>

        <div style={{ background: '#fff', padding: '40px', borderRadius: '15px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }}>
          <h2 style={{ fontSize: '32px', color: '#6a4c93', marginBottom: '30px', textAlign: 'center' }}>Why Choose Us?</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px' }}>
            {[
              { icon: '💰', title: 'Best Price Guarantee', text: "We'll match any competitor's price plus give you 5% off" },
              { icon: '📞', title: '24/7 Support', text: 'Our expert team is always available to help' },
              { icon: '✈️', title: 'Flexible Payments', text: 'Low deposits from £49pp and payment plans available' },
            ].map((feature, idx) => (
              <div key={idx}>
                <div style={{ fontSize: '48px', marginBottom: '15px' }}>{feature.icon}</div>
                <h3 style={{ fontSize: '20px', color: '#333', marginBottom: '10px' }}>{feature.title}</h3>
                <p style={{ color: '#666', lineHeight: '1.6' }}>{feature.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default About;
